import { useState, useEffect, FC } from 'react';
import { packsClient } from 'lib/clients';
import { useRouter } from 'next/router';
import { SelectInput } from 'components/controls/select-input';
import { useSWRConfig } from 'swr';

type Props = {
  onClose: Function;
}

export const Search: FC<Props> = ({onClose}) => {
  const { cache } = useSWRConfig()
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [value, setValue] = useState(cache.get('search') || '');
  const router = useRouter();
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (value.trim().length <= 2) {
      return setSuggestions([]);
    }

    setIsProcessing(true);

    const timeout = setTimeout(() => {
      (async () => {
        const { data } = await packsClient.searchPacks(value);
        setSuggestions(data);
        setIsProcessing(false);
      })();
    }, 300);

    return () => {
      clearTimeout(timeout);
      setIsProcessing(false);
    };
  }, [value]);

  const goto = (packId: string) => {
    onClose();
    router.push(`/packs/${packId}`)
  }

  const handleChange = (value: string) => {
    cache.set('search', value);
    setValue(value);
  }

  const handleBlur = () => {
    onClose();
  }

  return (
    <SelectInput
      value={value}
      onChange={(value) => handleChange(value)}
      onSelect={(selected) => goto(selected.id)}
      onBlur={() => handleBlur()}
      placeholder="Search all packs"
      rawData={suggestions}
      width="100%"
      boxHoverColor="border.500"
      BoxProps={{backgroundColor: 'var(--color-white)', borderRadius: 50}}
      InputProps={{borderRadius: 50}}
      ButtonProps={{borderRadius: 0}}
      isProcessing={isProcessing}
    />
  );
}
